import { Typography } from '@mui/material'
import { tss } from 'tss-react'
import { typography as textStyles } from '~/common/styles/typography'
import { TextColorVariant, TextProps, TypographyVariant } from '../types'
import { getTextColor } from './primitives'

/**
 * Renders text based on typography
 */
export const DefaultText = ({
  children,
  typography = 'body1',
  className,
  color = 'primary',
  ...rest
}: Omit<TextProps, 'variant'>) => {
  const { cx, classes } = useStyles({ typography, color })
  return (
    <Typography className={cx(classes.root, className)} {...rest}>
      {children}
    </Typography>
  )
}

const useStyles = tss
  .withParams<{ typography: TypographyVariant; color: TextColorVariant }>()
  .create(({ typography, color }) => ({
    root: {
      ...textStyles[typography],
      color: getTextColor(color),
    },
  }))
